import Config from "../config/Config";
export default class BaseApi {
  REACT_APP_SERVER_URL = Config.REACT_APP_SERVER_URL

  getToken() {
    return localStorage.getItem('access_token');
  }
}